<footer id="footer" class="global-footer">
    <div class="container">
        <div class="row">
            <div class="three-quarters">
                <ul class="footer-links">
                    <li>
                        <a
                            [routerLink]="[currentRoute]"
                            (click)="backToTop($event)"
                            >Back to Top</a
                        >
                    </li>
                    <li>
                        <a href="https://cdss.ca.gov/conditions-of-use"
                            >Conditions of Use</a
                        >
                    </li>
                    <li>
                        <a href="https://cdss.ca.gov/accessibility"
                            >Accessibility</a
                        >
                    </li>
                    <li>
                        <a href="https://cdss.ca.gov/notice-on-collection"
                            >Notice On Collection</a
                        >
                    </li>
                    <li>
                        <a href="https://cdss.ca.gov/privacy-policy"
                            >Privacy Policy</a
                        >
                    </li>
                    <li>
                        <a href="https://cdss.ca.gov/contact-us">Contact Us</a>
                    </li>
                </ul>
            </div>
            <div class="quarter text-right">
                <ul class="socialsharer-container">
                    <li>
                        <a
                            href="https://www.flickr.com/groups/californiagovernment"
                        >
                            <span
                                class="ca-gov-icon-flickr"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">Flickr</span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.pinterest.com/cagovernment/">
                            <span
                                class="ca-gov-icon-pinterest"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">Pinterest</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://twitter.com/cagovernment"
                            title="Twitter Link"
                        >
                            <span
                                class="ca-gov-icon-twitter"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">Twitter</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.youtube.com/user/californiagovernment"
                        >
                            <span
                                class="ca-gov-icon-youtube"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">YouTube</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Copyright Statement -->
    <div class="white copyright">
        <div class="container">
            {{ title }} v{{ version }}
            <br />
            Copyright &copy; {{ year }} State of California
        </div>
    </div>
</footer>

<!-- Extra Decorative Content -->
<div class="decoration-last"></div>
